import React from "react";
import { Box } from "@mui/material";

// The rubber stamp across an annulled radicado's card. Laid over the content
// rather than replacing it, so the number, the asunto and the date stay
// readable underneath; it ignores the pointer so the card still opens.
// The parent has to be position: relative.
export default function AnnulledStamp({ size = 28 }) {
  return (
    <Box
      aria-label="Radicado anulado"
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      <Box
        component="span"
        sx={{
          transform: "rotate(-14deg)",
          border: "3px solid",
          borderColor: "rgba(211, 47, 47, 0.55)",
          borderRadius: 1,
          color: "rgba(211, 47, 47, 0.55)",
          fontSize: size,
          fontWeight: 800,
          letterSpacing: "0.12em",
          lineHeight: 1,
          px: 1.5,
          py: 0.5,
          textTransform: "uppercase",
          backgroundColor: "rgba(255, 255, 255, 0.35)",
          userSelect: "none",
        }}
      >
        Anulado
      </Box>
    </Box>
  );
}
